import { useState, useEffect, useCallback } from 'react';
import { API } from 'aws-amplify';
import { GET_ORG_ZONES } from '../graphql/queries';

export interface Zone {
  id: string;
  name: string;
  code: string;
  description?: string;
  sortOrder: number;
  orgId?: string;
  isSystem: boolean;
  isDeleted?: boolean;
}

export default function useOrgZones() {
  const orgID = (global as any)?.me?.orgID;
  const [zones, setZones] = useState<Zone[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchZones = useCallback(
    async (showLoading = true) => {
      if (!orgID) return;

      try {
        if (showLoading) setIsLoading(true);
        setError(null);

        const result: any = await API.graphql({
          query: GET_ORG_ZONES as any,
          variables: {
            request: JSON.stringify({ orgId: orgID }),
          },
        });

        const parsed = JSON.parse(result.data.getOrgZones);

        if (parsed.success) {
          setZones(parsed.data?.zones ?? []);
        } else {
          setError(parsed.error ?? 'Failed to fetch zones');
        }
      } catch (err: any) {
        console.error('Error fetching org zones:', err);
        setError(err?.message ?? 'Failed to fetch zones');
      } finally {
        setIsLoading(false);
      }
    },
    [orgID]
  );

  useEffect(() => {
    fetchZones();
  }, [fetchZones]);

  return { zones, isLoading, error, refetch: () => fetchZones(false) };
}
